<template>
  <div :class="['contact-page', {'is-flag': $flag}]">
    <div class="top-banner" :style="{ backgroundImage: 'url(' + imgUrl + ')' }">
      <div class="banner-content">
        <h1>联系我们</h1>
        <p>期待与您的交流与合作</p>
      </div>
    </div>

    <section class="contact-section container">
      <div class="contact-grid">
        <div class="contact-card">
          <div class="icon-wrapper">
            <i class="el-icon-phone-outline"></i>
          </div>
          <h3>服务热线</h3>
          <p>18969585538</p>
        </div>
        <div class="contact-card">
          <div class="icon-wrapper">
            <i class="el-icon-message"></i>
          </div>
          <h3>电子邮箱</h3>
          <p>contact@huitutech.com</p>
        </div>
        <div class="contact-card">
          <div class="icon-wrapper">
            <i class="el-icon-location-outline"></i>
          </div>
          <h3>公司地址</h3>
          <p>浙江省丽水市龙泉市剑池街道瓯江花园1-134室</p>
        </div>
      </div>

      <div class="map-container-wrapper">
        <div id="mapContainer"></div>
        <div class="map-overlay" v-if="!$flag">
          <h4>汇图科技（浙江）有限公司</h4>
          <p>地址：浙江省丽水市龙泉市剑池街道瓯江花园1-134室</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'ContactUs',
  data() {
    return {
      imgUrl: this.$flag
        ? require('@/assets/imgs/banner1.png')
        : require('@/assets/imgs/concent.png'),
    }
  },
  mounted() {
    this.initMap();
  },
  methods: {
    initMap() {
      if (typeof window.BMapGL === 'undefined') {
        setTimeout(this.initMap, 500);
        return;
      }
      const map = new window.BMapGL.Map('mapContainer')
      const point = new window.BMapGL.Point(119.164344, 28.071852)
      map.centerAndZoom(point, 18)
      const marker = new window.BMapGL.Marker(point)
      map.addOverlay(marker)
      const infoWindow = new window.BMapGL.InfoWindow(
        '汇图科技（浙江）有限公司<br/>地址: 浙江省丽水市龙泉市剑池街道瓯江花园1-134室'
      )
      marker.addEventListener('click', function () {
        this.openInfoWindow(infoWindow)
      })
      map.enableScrollWheelZoom(true)
    }
  }
}
</script>

<style lang="less" scoped>
@import "../assets/css/contact.less";
</style>
